export default __webpack_public_path__ + "static/media/WBTC.80c6afd1.png";